import api from './api';

const invoiceService = {
  /** Tenant-scoped server-side: admin=all, rep=their clinics, clinic=their own. */
  getInvoices: (params) => api.get('/invoices', { params }),
  getInvoiceById: (id) => api.get(`/invoices/${id}`),
  /**
   * THE LEDGER (9/2/26): every QuickBooks invoice for the clinics the caller may see, history
   * included, with the app's own not-yet-in-QuickBooks rows on top. Params: status
   * (all|open|overdue|partial|paid|needs_attention), clinicId, search, dateFrom, dateTo, page, limit.
   */
  getLedger: (params) => api.get('/invoices/ledger', { params }),
  /** MedEffects PDFs with complete original QuickBooks fallback, combined for a batch. Selection IDs stay in the authenticated body. */
  downloadPdf: (invoiceIds, { signal, sessionBinding } = {}) => api.post('/invoices/pdf', { invoiceIds }, {
    responseType: 'blob', timeout: 120000, signal, sessionBinding,
  }),
  /** Admin: pull the latest invoices and balances from QuickBooks into the mirror now. */
  syncFromQuickBooks: () => api.post('/admin/invoices/sync'),

  // PAYING IN THE APP (9/2/26) - BANK ACCOUNT (ACH) ONLY since 9/3/26. The bank details go from
  // the browser straight to Intuit's tokens endpoint (getPayConfig().tokenUrl); only the token
  // comes here. The server refuses any method but 'bank' with a 400.
  getPayConfig: () => api.get('/invoices/pay/config'),
  /** { invoiceIds, method: 'bank', token, payerName, expectedAmount } -> receipt. */
  pay: (body) => api.post('/invoices/pay', body),
  /** Payments the caller may see (clinic-scoped). Params: clinicId, status, page, limit. */
  getPayments: (params) => api.get('/invoices/payments', { params }),
  /** Admin: QuickBooks was not told about a payment that went through - try again. */
  retryRecord: (id) => api.post(`/admin/invoices/payments/${id}/record`),
  /** Admin: ask Intuit whether a bank debit settled or came back. */
  refreshPayment: (id) => api.post(`/admin/invoices/payments/${id}/refresh`),
  /** Admin: re-run a failed/needs_attention invoice. Never re-creates a created one. */
  retry: (id) => api.post(`/admin/invoices/${id}/retry`),
};

export default invoiceService;
